<!-- Detalle de un día («Ver» o «Generar y ver») -->
<app-odoo-archivo-dia *ngIf="detalle as d" [fecha]="d.fecha" [previa]="d.previa" [puedeEditar]="puedeEditar" [version]="version" [subiendo]="subiendo === d.fecha"
  (volver)="volver()" (regenerar)="abrirRegenerar($event.fecha, $event.subidoISO)" (subir)="subir($event.fecha, $event.yaSubido, $event.subidoISO)"></app-odoo-archivo-dia>

<ng-container *ngIf="!detalle">
  <ng-container *ngIf="vm$ | async as vm">
    <!-- Barra: cuándo se sube y generar una fecha -->
    <div class="od-toolbar">
      <span class="od-muted" *ngIf="vm.subida">{{ vm.subida }}</span>
      <span class="od-fin" style="display:inline-flex;gap:8px;align-items:center">
        <ng-container *ngIf="puedeEditar">
          <label class="od-input" style="color:var(--od-fg)">
            <od-icon name="cal"></od-icon>
            <input type="date" [(ngModel)]="fecha" [max]="maxFecha" aria-label="Fecha a generar">
          </label>
          <button type="button" class="od-btn od-btn-primary" [disabled]="!fecha || fecha > maxFecha" (click)="generarYVer()">
            <od-icon name="file"></od-icon>Generar y ver
          </button>
        </ng-container>
        <button type="button" class="od-btn" (click)="recargar()" title="Volver a consultar" aria-label="Volver a consultar"><od-icon name="refresh"></od-icon></button>
      </span>
    </div>

    <!-- Error al traer la lista -->
    <div class="od-alert" *ngIf="vm.error" role="alert">
      <od-icon name="alert" [size]="16"></od-icon>
      <div class="od-alert-tx"><b>No se pudo traer la lista de archivos.</b> {{ vm.error }}</div>
      <button type="button" class="od-btn od-btn-sm" (click)="recargar()">Reintentar</button>
    </div>

    <!-- Cargando -->
    <div *ngIf="vm.cargando && !vm.datos" aria-busy="true">
      <div class="od-skeleton" style="height:110px;margin-bottom:10px" *ngFor="let i of esperando; trackBy: porIndice"></div>
    </div>

    <ng-container *ngIf="vm.datos">
      <!-- Alerta de días faltantes -->
      <div class="od-alert" *ngIf="vm.aviso as av" role="alert">
        <od-icon name="alert" [size]="16"></od-icon>
        <div class="od-alert-tx"><b>{{ av.titulo }}</b> {{ av.texto }}</div>
      </div>

      <div class="od-empty" *ngIf="!vm.tarjetas.length && !vm.faltantes.length">
        <od-icon name="file" [size]="28"></od-icon>
        <b>Todavía no hay archivos del día</b>
        <span>Se generan solos cada día a la hora configurada{{ puedeEditar ? ', o elige una fecha arriba y pulsa «Generar y ver»' : '' }}.</span>
      </div>

      <div [style.opacity]="vm.cargando ? .6 : 1">
        <!-- Tarjetas: primero los días que faltan -->
        <article class="od-day od-day-err" *ngFor="let t of vm.faltantes; trackBy: porFecha" [attr.aria-label]="'Día por subir ' + t.titulo">
          <div class="od-day-h">
            <b>{{ t.titulo }}</b>
            <span class="od-muted" *ngIf="t.intentos">{{ t.intentos }} {{ t.intentos === 1 ? 'intento' : 'intentos' }}</span>
            <button type="button" class="od-btn od-btn-primary" *ngIf="puedeEditar" [disabled]="subiendo === t.fecha" (click)="subir(t.fecha)">
              <od-icon name="upload" [class.od-spin]="subiendo === t.fecha"></od-icon>{{ subiendo === t.fecha ? 'Subiendo…' : 'Subir ahora' }}
            </button>
          </div>
          <div class="od-day-r" *ngFor="let f of t.filas; trackBy: porClase">
            <b>{{ f.etiqueta }}</b>
            <span class="od-muted">{{ f.resumen }}</span>
            <ng-container *ngTemplateOutlet="recorrido; context: { f: f }"></ng-container>
          </div>
        </article>

        <article class="od-day" *ngFor="let t of vm.tarjetas; trackBy: porFecha">
          <div class="od-day-h">
            <b>{{ t.titulo }}</b>
            <span class="od-muted" *ngIf="t.subidoEn">{{ t.subidoEn }}</span>
            <button type="button" class="od-btn" (click)="ver(t.fecha)"><od-icon name="eye"></od-icon>Ver</button>
            <button type="button" class="od-btn" *ngIf="t.archivos.length" [disabled]="descargando === t.fecha" (click)="descargarDia(t)">
              <od-icon name="down"></od-icon>{{ descargando === t.fecha ? 'Descargando…' : 'Descargar' }}
            </button>
            <button type="button" class="od-btn" *ngIf="puedeEditar" (click)="subir(t.fecha, t.yaSubido, t.subidoISO)"><od-icon name="refresh"></od-icon>Regenerar</button>
          </div>
          <div class="od-day-r" *ngFor="let f of t.filas; trackBy: porClase">
            <b>{{ f.etiqueta }}</b>
            <span class="od-muted">{{ f.resumen }}</span>
            <ng-container *ngTemplateOutlet="recorrido; context: { f: f }"></ng-container>
          </div>
        </article>
      </div>

      <div class="od-toolbar" *ngIf="vm.datos.total > limite" style="margin-top:8px">
        <span class="od-muted">{{ vm.datos.total }} días con archivos</span>
        <span class="od-fin" style="display:inline-flex;gap:8px;align-items:center">
          <button type="button" class="od-btn od-btn-sm" [disabled]="page === 1" (click)="ir(page - 1)">Anterior</button>
          <span class="od-muted">{{ page }} / {{ totalPaginas(vm.datos.total) }}</span>
          <button type="button" class="od-btn od-btn-sm" [disabled]="page >= totalPaginas(vm.datos.total)" (click)="ir(page + 1)">Siguiente</button>
        </span>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<!-- Recorrido de un archivo: Generado → Subido al buzón → Recibido por 3mit (este último aún no se puede saber) -->
<ng-template #recorrido let-f="f">
  <span style="display:inline-flex;align-items:center;gap:6px;flex-wrap:wrap;justify-content:flex-end">
    <ng-container *ngIf="f.estado === 'falta'">
      <span class="od-badge od-badge-dash">Sin archivo</span>
    </ng-container>
    <ng-container *ngIf="f.estado !== 'falta'">
      <span class="od-badge od-badge-solid">Generado</span>
      <span class="od-muted" aria-hidden="true">→</span>
      <span class="od-badge od-badge-problem" *ngIf="f.estado === 'error'" [title]="f.archivo?.error || ''"><od-icon name="alert" [size]="12"></od-icon>No se pudo subir</span>
      <ng-container *ngIf="f.estado === 'ok'">
        <span class="od-badge od-badge-solid">Subido al buzón</span>
        <span class="od-muted" aria-hidden="true">→</span>
        <span class="od-badge od-badge-solid" *ngIf="f.recibido === 'si'">Recibido por 3mit</span>
        <span class="od-badge od-badge-problem" *ngIf="f.recibido === 'problema'"><od-icon name="alert" [size]="12"></od-icon>3mit con problemas</span>
        <span class="od-badge od-badge-dash" *ngIf="!f.recibido" title="Todavía no hay forma de saber si 3mit lo recibió">Recibido por 3mit</span>
      </ng-container>
    </ng-container>
  </span>
</ng-template>

<!-- Diálogo «Regenerar» -->
<div class="od-dialog-fondo" *ngIf="regen as r" (click)="cerrarRegenerar()">
  <div #dlg class="od-dialog" role="dialog" aria-modal="true" aria-labelledby="odRegenTitulo" (click)="$event.stopPropagation()" (keydown)="atrapar($event, dlg)">
    <h4 id="odRegenTitulo" style="font-size:16px;font-weight:700">¿Volver a generar el {{ r.titulo }}?</h4>
    <p class="od-muted" style="font-size:13px;margin-top:8px">
      Ese día ya se subió{{ r.subidoEn ? ' el ' + r.subidoEn : '' }}. Si lo generas otra vez, 3mit recibe los dos archivos de nuevo.
    </p>
    <label for="odRegenMotivo" style="display:block;font-weight:600;font-size:13px;margin:14px 0 6px">Motivo</label>
    <label class="od-input" style="align-items:flex-start;color:var(--od-fg)">
      <textarea #campoMotivo id="odRegenMotivo" rows="2" maxlength="300" [(ngModel)]="motivo" placeholder="3mit avisó que el archivo de pagos llegó vacío."
        style="border:0;outline:0;background:transparent;font:inherit;width:100%;resize:vertical"></textarea>
    </label>
    <div class="od-dialog-pie">
      <button type="button" class="od-btn" [disabled]="regenerando" (click)="cerrarRegenerar()">Cancelar</button>
      <button type="button" class="od-btn od-btn-primary" [disabled]="!motivoValido || regenerando" (click)="confirmarRegenerar()">
        {{ regenerando ? 'Generando…' : 'Generar y volver a subir' }}
      </button>
    </div>
  </div>
</div>
